/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DropZoneFileContainer: any = {
    display: 'inlineFlex',
    position: 'relative',
    width: 120,
    height: 'auto',
};

export const DropZoneFileRemoveIcon: any = {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
    cursor: 'pointer',
};
